import React, { useState } from "react";
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
import RiderMarker from "./RiderMarker";

function Map(props) {
  const [map, setMap] = useState(null);
  const loadRef = (map) => setMap(map);

  if (props.riders.length > 0 && map) {
    const bounds = new window.google.maps.LatLngBounds();
    props.riders.forEach((rider) => {
      bounds.extend(
        new window.google.maps.LatLng(
          rider.riderPosition.latitude,
          rider.riderPosition.longitude
        )
      );
      map.fitBounds(bounds);
    });
  }

  return (
    <GoogleMap
      ref={loadRef}
      defaultZoom={8}
      zoom={13}
      options={{ streetViewControl: false }}
    >
      {props.riders?.map((rider) => {
        return <RiderMarker key={rider.id} rider={rider} />;
      })}
    </GoogleMap>
  );
}

export default withScriptjs(withGoogleMap(Map));
